import "./scss/style.scss"

import React, {Suspense, useEffect, useState} from "react"
import {BrowserRouter, Route, Routes} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {useRecoilState} from "recoil"
import {useDispatch} from "react-redux"

import {CSpinner} from "@coreui/react-pro"

import {authAtom} from "@asset/AuthWrapper"
import {AnimateBalloon} from "@asset/Animate"

import AppPusher from "@component/AppPusher"
import AppMeta from "@component/AppMeta"

import "@src/i18n"

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"))
// Pages
const Login = React.lazy(() => import("@view/pages/login/Login"))

const loading = (
    <div className={"mt-5 pt-5 text-center"}>
        <CSpinner color={"success"} variant={"border"}/>
    </div>
)

const App = () => {
    const dispatch = useDispatch()

    const [auth] = useRecoilState(authAtom)
    const [languages] = useState(["pl", "en", "ua", "hu"])
    const [loader, setLoader] = useState(true)

    const {i18n} = useTranslation()

    useEffect(() => {
        if (!auth?.token) setLoader(true)
    }, [auth])

    useEffect(() => {
        if (!loader) {
            let currentLanguage = localStorage.getItem("setLanguage") || "pl"

            languages.map((item) => {
                if (localStorage.getItem(item) !== null)
                    i18n.addResourceBundle(item, "translation", JSON.parse(localStorage.getItem(item)), true, true)
            })

            i18n.changeLanguage(currentLanguage).then()
        }
    }, [loader])

    useEffect(() => {
        setLoader(localStorage.getItem("loaded") !== "false")
    }, [])

    useEffect(() => {
        dispatch({type: "set", sidebarUnfoldable: false})
        if (localStorage.getItem("notifications"))
            dispatch({type: 'set', asideCount: JSON.parse(localStorage.getItem("notifications")).filter((n) => n.new).length})
    })

    return (
        <BrowserRouter>
            <Suspense fallback={loading}>
                <AppPusher/>
                {!auth?.token && <AppMeta/>}

                {(!auth?.token || loader) && <AnimateBalloon/>}
                {(!auth?.token || loader) && <Login loader={loader} setLoader={setLoader} languages={languages} token={auth?.token}/>}

                {/*{(auth?.token) &&*/}
                {/*    <AppPusher/>}*/}

                {(auth?.token && !loader) &&
                    <Routes>
                        <Route path="*" element={<DefaultLayout fallback={loading}/>}/>
                    </Routes>
                }
            </Suspense>
        </BrowserRouter>
    )
}

export default App
